export default __webpack_public_path__ + "static/media/V2_Aviso_LegalAPP_anapat.a8e1ab28.pdf";